<template>
  <section class="py-5 goddes-page">
    <div class="container text-center">
      <header class="mb-5">
        <h1 class="page-title">璀璨女神臻顏逆齡系列</h1>
      </header>
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <img src="/inritek-web/images/goddes_web.png" alt="Goddes Brand" class="img-fluid rounded shadow-sm" />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.page-title { font-size: 4rem; font-weight: 700; margin-bottom: 0.5rem; }
.img-fluid { max-width: 100%; height: auto; }
</style>
